module.exports = __webpack_public_path__ + "img/Site-Districom-service-pro.e1f41d95.jpg";